import { AnyAction } from 'redux';
import actionTypes from '../types/detailTypes';

const initialState = {
  claimDetails: {},
  mandatoryClassifications: {},
  reloadCurrentPage: 0,
  isCashlessSubmit: null,
  linkAbhaClick: false,
  sinceYearDate: null,
  claimDetailsPayerType: '',
  linkMoreDocsToAbha: false,
  showClaimDetailData: false,
  isCancelledClaim: false,
  isInpatientReconsiderAction: false,
  timelineColorCode: {},
  isDeleteModal: false,
  isArtemisClaim: false,
};

const reducer = (
  state: any = initialState,
  action: AnyAction,
): any => {
  switch (action.type) {
    case actionTypes.SET_CLAIM_DATA:
      return {
        ...state,
        claimDetails: action.payload,
      };
    case actionTypes.CLAIM_DETAILS_PAYER_TYPE:
      return {
        ...state,
        claimDetailsPayerType: action.payload,
      };
      case actionTypes.IS_CANCEL_CLICKED:
        return {
          ...state,
          isCancelledClaim: action.payload,
        };
    case actionTypes.RELOAD_CURRENT_PAGE:
      return {
        ...state,
        reloadCurrentPage: state.reloadCurrentPage + 1,
      };
    case actionTypes.SET_CLAIM_MANDATORY_CLASSIFICATION:
      return {
        ...state,
        mandatoryClassifications: action.payload,
      };
    case actionTypes.SET_IS_CASHLESS_SUBMIT:
      return {
        ...state,
        isCashlessSubmit: action.payload,
      };
    case actionTypes.SET_LINK_ABHA_CLICK:
      return {
        ...state,
        linkAbhaClick: action.payload,
      };
    case actionTypes.SET_INPATIENT_RECONSIDER_ACTION:
      return {
        ...state,
        isInpatientReconsiderAction: action.payload,
      };
    case actionTypes.SET_LINK_MORE_DOCS_TO_ABHA:
      return {
        ...state,
        linkMoreDocsToAbha: action.payload,
      };
    case actionTypes.SET_LINKED_TO_ABHA:
      return {
        ...state,
        claimDetails: {
          ...state.claimDetails,
          linkedToAbha: action.payload,
        },
      };
    case actionTypes.SET_SINCE_YEAR_DATE:
      return {
        ...state,
        sinceYearDate: action.payload,
      };
    case actionTypes.SET_REASON_FOR_CANCELLAION:
      return {
        ...state,
        claimDetails: {
          ...state.claimDetails,
          reasonForCancellation: action.payload,
        },
      };
    case actionTypes.SHOW_CLAIM_DETAIL_DATA:
      return {
        ...state,
        showClaimDetailData: action.payload,
      };
    case actionTypes.SET_TIMELINE_COLOR_CODE:
      return {
        ...state,
        timelineColorCode: action.payload,
      };
    case actionTypes.IS_DETAIL_MODAL:
      return {
        ...state,
        isDeleteModal: action.payload,
      };
    case actionTypes.SET_ARTEMIS_CLAIM:
      return {
        ...state,
        isArtemisClaim: action.payload,
      };
    default: return state;
  }
};

export { reducer as admissionDetailsReducer };
